let { getEnvSubdomain } = require ('~/src/util');

module.exports = {
  ws: `wss://px.dataseal.io`,
  fe: 'https://dataseal.io',
  recaptcha: {
    sitekey: '6LdnynIgAAAAALpYfl7m2S-a_sPyWYJzNlYWqjwO'
  }
};
